import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

/**
 * Envuelve un componente y valida que el usuario tenga el privilegio dado.
 * @param {string} privilegeKey — La clave de privileges (p.ej. "contact")
 * @param {ReactNode} children — El módulo a renderizar si pasa la validación
 */
const ProtectedRoute = ({ privilegeKey, children }) => {
  const { user } = useContext(AuthContext);

  // Si no hay usuario logeado, redirige al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si el usuario no tiene ese privilegio, redirige a Home
  if (!user.privileges?.[privilegeKey]) {
    return <Navigate to="/home" replace />;
  }

  // Si todo OK, renderiza el módulo
  return children;
};

export default ProtectedRoute;
